'use strict';

require('./kendo.core.js');
var commonEngine = require('@progress/kendo-spreadsheet-common');
require('./kendo.licensing.js');
require('@progress/kendo-licensing');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var commonEngine__namespace = /*#__PURE__*/_interopNamespaceDefault(commonEngine);

(function(kendo) {
    let $ = kendo.jQuery;
    $.extend(kendo.spreadsheet, commonEngine__namespace);
    kendo.spreadsheet.commonEngine = commonEngine__namespace;
})(kendo);
